import { QuestionVariety } from "./Definition";
import { MultiValueQuestion } from "./MultiValueQuestion";

export default class CheckboxesQuestion extends MultiValueQuestion {
  get type(): QuestionVariety {
    return "checkboxes";
  }
}
